import React from 'react';
import { Tooltip } from '@mui/material';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

const InteractiveShield = ({ 
    imageSrc, 
    altText, 
    verifyUrl, 
    shieldIcon, 
    shieldPosition = 'top-right', 
    floatingIcons,
    mediaType = 'image' // <-- NEW: Tell component what to render
}) => {
    const { t } = useTranslation();
    
    // Set coordinates to 0 to place it perfectly in the corner
    const positioning = shieldPosition === 'top-left' 
        ? { top: '0', left: '0' } 
        : { top: '0', right: '0' };

    const isVideo = mediaType === 'video';

    return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%', height: '100%' }}>
            <div style={{ position: 'relative', display: 'inline-block', lineHeight: 0, width: '100%', maxWidth: 'max-content' }}>
                
                {/* Dynamically Render Video or Image */}
                {isVideo ? (
                    <video 
                        src={imageSrc} 
                        autoPlay 
                        loop 
                        muted 
                        playsInline
                        style={{ maxWidth: '100%', maxHeight: '350px', width: 'auto', height: '100%', display: 'block', objectFit: 'contain' }}
                    />
                ) : (
                    <img 
                        src={imageSrc} 
                        alt={altText || "Shield Demo"} 
                        style={{ maxWidth: '100%', maxHeight: '350px', width: 'auto', height: 'auto', display: 'block', objectFit: 'contain' }}
                    />
                )}

                {/* Floating Icons (for Social Demo) */}
                {floatingIcons && floatingIcons.map((icon, idx) => (
                    <motion.div
                        key={idx}
                        initial={{ opacity: 0, y: 0, scale: 0.5 }}
                        animate={{ opacity: [0, 1, 0], y: -60, scale: [0.8, 1.2, 0.8] }}
                        transition={{ duration: 2.5, repeat: Infinity, delay: icon.delay, ease: "easeInOut" }}
                        style={{ position: 'absolute', top: icon.top, left: icon.left, fontSize: icon.size || '2.5rem', pointerEvents: 'none', zIndex: 5, filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.5))' }}
                    >
                        {icon.emoji}
                    </motion.div>
                ))}

                {/* Clickable Shield Overlay */}
                <Tooltip
                    placement={shieldPosition === 'top-left' ? 'right' : 'left'}
                    arrow
                    componentsProps={{
                        tooltip: { sx: { backgroundColor: '#171F29', opacity: '1 !important', boxShadow: '0 8px 32px rgba(0,0,0,0.9)', padding: '10px 14px', border: '1px solid rgba(255,255,255,0.1)' } },
                        arrow: { sx: { color: '#171F29', opacity: '1 !important' } }
                    }}
                    title={<div style={{ color: 'white', fontSize: '0.75rem', fontWeight: 600, fontFamily: 'Roboto, sans-serif', letterSpacing: '0.5px' }}>{t('industryApplications.interactive.shield.verifyTooltip')}</div>}
                >
                    <img 
                        src={shieldIcon}
                        alt="Vetra Shield"
                        onClick={() => window.open(verifyUrl || 'https://www.vetra-ai.com/', '_blank')}
                        style={{
                            position: 'absolute',
                            ...positioning,
                            width: '40px', // Standard shield size
                            height: 'auto',
                            cursor: 'pointer',
                            filter: 'drop-shadow(0 2px 6px rgba(0,0,0,0.8))',
                            transition: 'transform 0.2s ease, filter 0.2s ease',
                            zIndex: 10
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.transform = 'scale(1.05)';
                            e.currentTarget.style.filter = 'drop-shadow(0 4px 10px rgba(0,0,0,0.9)) brightness(1.2)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.transform = 'scale(1)';
                            e.currentTarget.style.filter = 'drop-shadow(0 2px 6px rgba(0,0,0,0.8))';
                        }}
                    />
                </Tooltip>
            </div>
        </div>
    );
};

export default InteractiveShield;